const possibleChar = 'QAZWSXEDCRFVTGBYHNUJMIKLP123456789';

export const generateCode = (length: number) => {
  let builder = '';

  for (let i = 1; i <= length; i++) {
    const randNum = Math.floor(Math.random() * possibleChar.length);
    const ch = possibleChar.charAt(randNum);
    builder += ch;
  }

  return builder;
};

export const formatCode = (
  occurence: number,
  activationCode: string,
  delimiter: string
) => {
  let sb = '';

  for (let i = 0; i < activationCode.length; i++) {
    if (i % occurence === 0 && i !== 0) {
      sb += delimiter;
    }

    sb += activationCode[i];
  }

  return sb;
};
